import classNames from 'classnames';
import Text from 'style-guide/Typography/Text';
import ProgressBarWrapper from './ProgressBarWrapper';
import { getProgressText, percentCount } from './helper';

const ProgressBar = ({ className, percent = 0, simple = false }) => (
  <ProgressBarWrapper className={classNames(className, 'percent')}>
    {!simple ? (
      <div className='d-flex justify-content-between mb--24'>
        <Text weight={600}>{getProgressText(percent)}</Text>
        <Text>{percent}%</Text>
      </div>
    ) : null}
    <div className='block'>
      <div
        style={{
          width: `${percentCount(percent)}%`,
        }}
        className={classNames({ completed: percent >= 100 }, 'progress')}
      />
    </div>
  </ProgressBarWrapper>
);

export default ProgressBar;
